import {FooterConfig, GetConfigParams} from '../shared';
import getArhiConfig from './arhi';

const getThriveConfig = (config: GetConfigParams): FooterConfig => {
  const arhiConfig = getArhiConfig(config);
  return {
    ...arhiConfig,
    id: 'footer-thrive',
    smallFooterConfig: {
      ...arhiConfig.smallFooterConfig,
      id: 'small-footer-thrive'
    }
  };
};

export default getThriveConfig;
